module.exports = __webpack_public_path__ + "static/media/Screen Shot 2020-05-25 at 6.5a63cf74.45";